var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoreButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_17105",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 17105",
    transform: "translate(-2246 -4927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_5097",
    "data-name": "\\u6955\\u5186\\u5F62 5097",
    transform: "translate(2246 4927)",
    fill: "#f2f2f2",
    stroke: "#d0d0d0",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(2271 4962.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more-horizotnal",
    transform: "translate(3 9.792)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5101",
    "data-name": "\\u6955\\u5186\\u5F62 5101",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(17 -0.008)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5102",
    "data-name": "\\u6955\\u5186\\u5F62 5102",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(34 -0.008)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5103",
    "data-name": "\\u6955\\u5186\\u5F62 5103",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(0 -0.008)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreButton);
export default __webpack_public_path__ + "static/media/moreButton.a132f06f9c86954adb15f1d80c5c73c6.svg";
export { ForwardRef as ReactComponent };